import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UserMenu from "../tools/UserMenu";
import SMenu from "../menu/";
import Logo from "../tools/Logo";
import { mixin } from '@/utils/mixin.js';
export default {
  name: 'GlobalHeader',
  components: {
    UserMenu: UserMenu,
    SMenu: SMenu,
    Logo: Logo
  },
  mixins: [mixin],
  props: {
    mode: {
      type: String,
      // sidemenu, topmenu
      default: 'sidemenu'
    },
    menus: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    device: {
      type: String,
      required: false,
      default: 'desktop'
    }
  },
  data: function data() {
    return {
      titleLogo: '',
      waterName: '',
      tabList: [{
        id: 0,
        name: '驾驶舱'
      }, {
        id: 1,
        name: '环境一张图'
      }, {
        id: 2,
        name: '污染源一张图'
      }, {
        id: 3,
        name: '站点档案'
      }],
      treeData: [],
      selectedKeys: [],
      //设置选中的树节点
      checkedKeys: [],
      autoExpandParent: true,
      iExpandedKeys: [],
      leftMenus: [],
      headerBarFixed: false,
      topMenuStyle: {
        headerIndexLeft: {},
        topNavHeader: {},
        headerIndexRight: {},
        topSmenuStyle: {}
      },
      topMenuMode: 'top',
      constructMenu: null,
      projectMenu: null
    };
  },
  watch: {
    /** 监听设备变化 */
    device: function device() {
      if (this.mode === 'topmenu') {
        this.buildTopMenuStyle();
      }

      if (this.device == 'mobile') {
        this.$emit('showMenu', true);
      } else {
        this.$emit('showMenu', false);
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.handleScroll); //update-begin--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----

    if (this.mode === 'topmenu') {
      this.buildTopMenuStyle();
    }

    if (this.device == 'mobile') {
      this.$emit('showMenu', true);
    } else {
      this.$emit('showMenu', false);
    } //update-end--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----


    this.$store.dispatch('ToggleTheme', 'dark');
    this.titleLogo = window.localStorage.getItem('titleLogo');
    this.waterName = window.localStorage.getItem('waterName');
  },
  created: function created() {
    var _this = this;

    this.treeData = this.menus.map(function (v) {
      return {
        title: v.meta.title,
        key: v.path,
        selectable: true,
        children: _this.changeName(v.children)
      };
    });
  },
  methods: {
    goIndex: function goIndex() {
      if (window.localStorage.getItem('homeUrl')) {
        this.$router.push(window.localStorage.getItem('homeUrl'));
      } else {
        this.$router.push('/ds/view');
      }
    },
    changeName: function changeName(ary) {
      var _this2 = this;

      if (!ary) return [];
      return ary.map(function (v) {
        return {
          title: v.meta.title,
          key: v.path,
          selectable: true,
          children: _this2.changeName(v.children)
        };
      });
    },
    toPage: function toPage(item, isEmit) {
      if (item.children && item.children.length > 0) {
        return;
      }

      if (window.location.href.indexOf(item.path) == -1) {
        this.$bus.$emit('showProject', 'show', false);
        this.$bus.$emit('showSite', 'show', false);

        if (window.location.href.indexOf('/online/data/cn3020') != -1) {
          this.$bus.$emit('showSite', 'show', true);
          this.$bus.$emit('showProject', 'show', false);
        }
      }

      this.$router.push(item.path);
    },
    handleScroll: function handleScroll() {
      if (this.autoHideHeader) {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        if (scrollTop > 100) {
          this.headerBarFixed = true;
        } else {
          this.headerBarFixed = false;
        }
      } else {
        this.headerBarFixed = false;
      }
    },
    toggle: function toggle() {
      // this.$emit('toggle')
      this.$emit('showMenu', 'click');
    },
    buildTopMenuStyle: function buildTopMenuStyle() {
      if (this.mode === 'topmenu') {
        if (this.device === 'mobile') {
          // 手机端需要清空样式，否则显示会错乱
          this.topMenuStyle.topNavHeader = {};
          this.topMenuStyle.topSmenuStyle = {};
          this.topMenuStyle.headerIndexRight = {};
          this.topMenuStyle.headerIndexLeft = {};
        } else {
          var rightWidth = '280px';
          this.topMenuStyle.topNavHeader = {
            'min-width': '185px'
          };
          this.topMenuStyle.topSmenuStyle = {
            width: 'calc(100% - 210px)'
          };
          this.topMenuStyle.headerIndexRight = {
            'min-width': rightWidth
          };
          this.topMenuStyle.headerIndexLeft = {
            width: "calc(100% - 50px)"
          };
        }
      }
    },
    onSelect: function onSelect(item) {
      this.menus.forEach(function (v) {
        v.showMenu = false;
      });
      item.showMenu = true;
      this.$forceUpdate();
      this.topMenuSelect(item.id);
    },
    clickMenu: function clickMenu(item) {
      if (item.meta.title == '项目管理') {
        if (window.location.href.indexOf('/oa/project/projectMap') == -1) {
          this.$router.push('/oa/project/projectMap');
          this.$bus.$emit('showProject', 'show', true);
          this.$bus.$emit('showSite', 'show', false);
        }
      }
    },
    getChildren: function getChildren(ary) {
      var that = this;
      return ary.map(function (v) {
        return {
          title: v.meta.title,
          key: v.component,
          children: v.children ? that.getChildren(v.children) : null,
          icon: v.meta.icon
        };
      });
    },
    topMenuSelect: function topMenuSelect(value) {
      var that = this;
      this.menus.forEach(function (v) {
        if (v.id == value) {
          if (typeof v.children !== 'undefined') {
            that.leftMenus = v.children;
            that.leftMenus.forEach(function (item) {
              if (item.meta.title == '工程建设') {
                that.constructMenu = that.getChildren(item.children);
                window.sessionStorage.setItem('constructMenu', JSON.stringify(that.constructMenu));
              } else if (item.meta.title == '项目信息') {
                that.projectMenu = that.getChildren(item.children);
                window.sessionStorage.setItem('projectMenu', JSON.stringify(that.projectMenu));
              }
            });
          } else {
            that.leftMenus = [];
          }
        }
      });
    },
    closeMenu: function closeMenu() {
      this.menus.forEach(function (v) {
        v.showMenu = false;
      });
      this.$forceUpdate();
    } //update-begin--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----

  }
};